export const CREDIT_CARD_FLAGS = new Map([
  ["default", "/media/svg/credit-card/flat/default.svg"],
  ["master", "/media/svg/credit-card/flat/mastercard.svg"],
  ["visa", "/media/svg/credit-card/flat/visa.svg"],
  ["amex", "/media/svg/credit-card/flat/amex.svg"],
  ["hipercard", "/media/svg/credit-card/flat/hipercard.svg"],
  ["elo", "/media/svg/credit-card/flat/elo.svg"],
]);
